import { AuthContext } from '@gen2/contexts/AuthContext';
import { useContext } from 'react';

export const useAuth = () => useContext(AuthContext);
